import {Label} from '@/components/ui/label';
import {Input} from '@/components/ui/input';
import {RewardFormData} from '../types';

interface FormStep2ContentProps {
    formData: RewardFormData;
    onChange: (data: Partial<RewardFormData>) => void;
    disabled: boolean;
}

export const FormStep2Content = ({formData, onChange, disabled}: FormStep2ContentProps) => {
    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Personalização de Cores</h3>

            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                    <Label htmlFor="button_color">Cor do Botão</Label>
                    <div className="flex gap-2 items-center">
                        <Input
                            id="button_color"
                            type="color"
                            value={formData.button_color}
                            onChange={(e) => onChange({button_color: e.target.value})}
                            className="h-10 w-16"
                            disabled={disabled}
                        />
                        <Input
                            type="text"
                            value={formData.button_color}
                            onChange={(e) => onChange({button_color: e.target.value})}
                            className="h-10 flex-1 font-mono text-xs"
                            disabled={disabled}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="button_text_color">Cor do Texto do Botão</Label>
                    <div className="flex gap-2 items-center">
                        <Input
                            id="button_text_color"
                            type="color"
                            value={formData.button_text_color}
                            onChange={(e) => onChange({button_text_color: e.target.value})}
                            className="h-10 w-16"
                            disabled={disabled}
                        />
                        <Input
                            type="text"
                            value={formData.button_text_color}
                            onChange={(e) => onChange({button_text_color: e.target.value})}
                            className="h-10 flex-1 font-mono text-xs"
                            disabled={disabled}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="background_color">Cor de Fundo</Label>
                    <div className="flex gap-2 items-center">
                        <Input
                            id="background_color"
                            type="color"
                            value={formData.background_color}
                            onChange={(e) => onChange({background_color: e.target.value})}
                            className="h-10 w-16"
                            disabled={disabled}
                        />
                        <Input
                            type="text"
                            value={formData.background_color}
                            onChange={(e) => onChange({background_color: e.target.value})}
                            className="h-10 flex-1 font-mono text-xs"
                            disabled={disabled}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="text_color">Cor do Texto</Label>
                    <div className="flex gap-2 items-center">
                        <Input
                            id="text_color"
                            type="color"
                            value={formData.text_color}
                            onChange={(e) => onChange({text_color: e.target.value})}
                            className="h-10 w-16"
                            disabled={disabled}
                        />
                        <Input
                            type="text"
                            value={formData.text_color}
                            onChange={(e) => onChange({text_color: e.target.value})}
                            className="h-10 flex-1 font-mono text-xs"
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};